import { useEffect, useState } from 'react';

import { useAppSelector } from 'app/store';

import { viewerModel } from 'entities/viewer';

import style from './index.module.scss';

export const FioAccount = () => {
  const [fio, setFio] = useState<string>('');
  const accountInfo = useAppSelector(viewerModel.me.selectors.selectViewerProfile);

  useEffect(() => {
    if (accountInfo) {
      setFio(`${accountInfo?.lastName} ${accountInfo?.name} ${accountInfo?.middleName ?? ''}`);
    }
  }, [accountInfo]);

  return <span className={style.accountFio}>{fio}</span>;
};
